module.exports = __webpack_public_path__ + "img/campaigns.cc850715.jpg";